// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"PageWrapper_pageWrapper__9uyyU"};